import React, { useState } from 'react';

import { API } from 'constants';
import client from '../../../../services/template-api';

import { updateOrderKeys } from '../../../../helpers/insertItemAtSpecificPositionWithOrderUpdate';

import { defaultErrorMessage } from '../../../../constants/errorMessages';

import ConfirmDeletionModalPattern from '../../../../design-system/ConfirmDeletionModalPattern/ConfirmDeletionModalPattern';

const DeleteContentModal = ({
    name,
    order,
    contentArray,
    playbookTemplateId,
    setContent,
    onClose,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorAlert, setErrorAlert] = useState(null);

    const handleDelete = async () => {
        try {
            setIsLoading(true);

            const filteredContent = contentArray.filter(
                (contentPiece) => contentPiece.order !== order
            );
            const filteredContentWithUpdatedOrders = updateOrderKeys(filteredContent);
            const requestBody = { details: { content: filteredContentWithUpdatedOrders } };

            const { data } = await client.patch(
                API.ROUTES.template.playbookTemplate + playbookTemplateId + '/',
                requestBody
            );

            const content = data.default_version?.details?.content || [];
            setContent(content);

            onClose();
        } catch (error) {
            setErrorAlert({ message: defaultErrorMessage, statusCode: error.response?.status });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <ConfirmDeletionModalPattern
            title="Delete Content"
            handleDelete={handleDelete}
            onClose={onClose}
            confirmationTextStart="Are you sure you want to delete the"
            confirmationTextEnd="Content?"
            entityName={name}
            errorAlert={errorAlert}
            isLoading={isLoading}
            setErrorAlert={setErrorAlert}
        />
    );
};

export default DeleteContentModal;
